// Guardian AI - Dispute Service Protocol Buffer Definition
// Handles fraud report disputes, mediator assignments, and resolution workflow

// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,import_extension=none,json_types=true"
// @generated from file guardianai/v1/dispute/dispute.proto (package guardianai.v1.dispute, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file guardianai/v1/dispute/dispute.proto.
 */
export const file_guardianai_v1_dispute_dispute: GenFile = /*@__PURE__*/
  fileDesc("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");

/**
 * @generated from message guardianai.v1.dispute.DisputeRequest
 */
export type DisputeRequest = Message<"guardianai.v1.dispute.DisputeRequest"> & {
  /**
   * User filing the dispute
   *
   * @generated from field: string initiator_user_id = 1;
   */
  initiatorUserId: string;

  /**
   * Other party involved
   *
   * @generated from field: string counterparty_user_id = 2;
   */
  counterpartyUserId: string;

  /**
   * Detailed description
   *
   * @generated from field: string description = 3;
   */
  description: string;

  /**
   * FRAUD_REPORT_DISPUTE, PAYMENT_DISPUTE, etc.
   *
   * @generated from field: string category = 4;
   */
  category: string;

  /**
   * Low, Medium, High, Urgent
   *
   * @generated from field: string priority = 5;
   */
  priority: string;

  /**
   * Description of supporting evidence
   *
   * @generated from field: string evidence_description = 6;
   */
  evidenceDescription: string;

  /**
   * URLs to evidence attachments
   *
   * @generated from field: repeated string attachment_urls = 7;
   */
  attachmentUrls: string[];

  /**
   * FRAUD_REPORT, PAYMENT, SERVICE, CONTRACT, GENERAL
   *
   * @generated from field: string dispute_type = 8;
   */
  disputeType: string;

  /**
   * ID of the related entity (report ID, transaction ID, etc.)
   *
   * @generated from field: string related_entity_id = 9;
   */
  relatedEntityId: string;

  /**
   * Type of related entity
   *
   * @generated from field: string related_entity_type = 10;
   */
  relatedEntityType: string;

  /**
   * Specific reason (for categorization)
   *
   * @generated from field: string reason = 11;
   */
  reason: string;

  /**
   * Reference to existing evidence IDs
   *
   * @generated from field: repeated string evidence_ids = 12;
   */
  evidenceIds: string[];
};

/**
 * @generated from message guardianai.v1.dispute.DisputeRequest
 */
export type DisputeRequestJson = {
  /**
   * User filing the dispute
   *
   * @generated from field: string initiator_user_id = 1;
   */
  initiatorUserId?: string;

  /**
   * Other party involved
   *
   * @generated from field: string counterparty_user_id = 2;
   */
  counterpartyUserId?: string;

  /**
   * Detailed description
   *
   * @generated from field: string description = 3;
   */
  description?: string;

  /**
   * FRAUD_REPORT_DISPUTE, PAYMENT_DISPUTE, etc.
   *
   * @generated from field: string category = 4;
   */
  category?: string;

  /**
   * Low, Medium, High, Urgent
   *
   * @generated from field: string priority = 5;
   */
  priority?: string;

  /**
   * Description of supporting evidence
   *
   * @generated from field: string evidence_description = 6;
   */
  evidenceDescription?: string;

  /**
   * URLs to evidence attachments
   *
   * @generated from field: repeated string attachment_urls = 7;
   */
  attachmentUrls?: string[];

  /**
   * FRAUD_REPORT, PAYMENT, SERVICE, CONTRACT, GENERAL
   *
   * @generated from field: string dispute_type = 8;
   */
  disputeType?: string;

  /**
   * ID of the related entity (report ID, transaction ID, etc.)
   *
   * @generated from field: string related_entity_id = 9;
   */
  relatedEntityId?: string;

  /**
   * Type of related entity
   *
   * @generated from field: string related_entity_type = 10;
   */
  relatedEntityType?: string;

  /**
   * Specific reason (for categorization)
   *
   * @generated from field: string reason = 11;
   */
  reason?: string;

  /**
   * Reference to existing evidence IDs
   *
   * @generated from field: repeated string evidence_ids = 12;
   */
  evidenceIds?: string[];
};

/**
 * Describes the message guardianai.v1.dispute.DisputeRequest.
 * Use `create(DisputeRequestSchema)` to create a new message.
 */
export const DisputeRequestSchema: GenMessage<DisputeRequest, {jsonType: DisputeRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_dispute_dispute, 0);

/**
 * @generated from message guardianai.v1.dispute.DisputeResponse
 */
export type DisputeResponse = Message<"guardianai.v1.dispute.DisputeResponse"> & {
  /**
   * @generated from field: string dispute_id = 1;
   */
  disputeId: string;

  /**
   * @generated from field: bool success = 2;
   */
  success: boolean;

  /**
   * @generated from field: string message = 3;
   */
  message: string;

  /**
   * @generated from field: guardianai.v1.dispute.Dispute dispute = 4;
   */
  dispute?: Dispute;
};

/**
 * @generated from message guardianai.v1.dispute.DisputeResponse
 */
export type DisputeResponseJson = {
  /**
   * @generated from field: string dispute_id = 1;
   */
  disputeId?: string;

  /**
   * @generated from field: bool success = 2;
   */
  success?: boolean;

  /**
   * @generated from field: string message = 3;
   */
  message?: string;

  /**
   * @generated from field: guardianai.v1.dispute.Dispute dispute = 4;
   */
  dispute?: DisputeJson;
};

/**
 * Describes the message guardianai.v1.dispute.DisputeResponse.
 * Use `create(DisputeResponseSchema)` to create a new message.
 */
export const DisputeResponseSchema: GenMessage<DisputeResponse, {jsonType: DisputeResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_dispute_dispute, 1);

/**
 * @generated from message guardianai.v1.dispute.GetDisputesForReportRequest
 */
export type GetDisputesForReportRequest = Message<"guardianai.v1.dispute.GetDisputesForReportRequest"> & {
  /**
   * @generated from field: string fraud_report_id = 1;
   */
  fraudReportId: string;

  /**
   * @generated from field: int32 limit = 2;
   */
  limit: number;

  /**
   * @generated from field: int32 offset = 3;
   */
  offset: number;
};

/**
 * @generated from message guardianai.v1.dispute.GetDisputesForReportRequest
 */
export type GetDisputesForReportRequestJson = {
  /**
   * @generated from field: string fraud_report_id = 1;
   */
  fraudReportId?: string;

  /**
   * @generated from field: int32 limit = 2;
   */
  limit?: number;

  /**
   * @generated from field: int32 offset = 3;
   */
  offset?: number;
};

/**
 * Describes the message guardianai.v1.dispute.GetDisputesForReportRequest.
 * Use `create(GetDisputesForReportRequestSchema)` to create a new message.
 */
export const GetDisputesForReportRequestSchema: GenMessage<GetDisputesForReportRequest, {jsonType: GetDisputesForReportRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_dispute_dispute, 2);

/**
 * @generated from message guardianai.v1.dispute.GetUserDisputesRequest
 */
export type GetUserDisputesRequest = Message<"guardianai.v1.dispute.GetUserDisputesRequest"> & {
  /**
   * @generated from field: string user_id = 1;
   */
  userId: string;

  /**
   * @generated from field: guardianai.v1.dispute.DisputeStatus status_filter = 2;
   */
  statusFilter: DisputeStatus;

  /**
   * @generated from field: int32 limit = 3;
   */
  limit: number;

  /**
   * @generated from field: int32 offset = 4;
   */
  offset: number;
};

/**
 * @generated from message guardianai.v1.dispute.GetUserDisputesRequest
 */
export type GetUserDisputesRequestJson = {
  /**
   * @generated from field: string user_id = 1;
   */
  userId?: string;

  /**
   * @generated from field: guardianai.v1.dispute.DisputeStatus status_filter = 2;
   */
  statusFilter?: DisputeStatusJson;

  /**
   * @generated from field: int32 limit = 3;
   */
  limit?: number;

  /**
   * @generated from field: int32 offset = 4;
   */
  offset?: number;
};

/**
 * Describes the message guardianai.v1.dispute.GetUserDisputesRequest.
 * Use `create(GetUserDisputesRequestSchema)` to create a new message.
 */
export const GetUserDisputesRequestSchema: GenMessage<GetUserDisputesRequest, {jsonType: GetUserDisputesRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_dispute_dispute, 3);

/**
 * @generated from message guardianai.v1.dispute.GetDisputeRequest
 */
export type GetDisputeRequest = Message<"guardianai.v1.dispute.GetDisputeRequest"> & {
  /**
   * @generated from field: string dispute_id = 1;
   */
  disputeId: string;
};

/**
 * @generated from message guardianai.v1.dispute.GetDisputeRequest
 */
export type GetDisputeRequestJson = {
  /**
   * @generated from field: string dispute_id = 1;
   */
  disputeId?: string;
};

/**
 * Describes the message guardianai.v1.dispute.GetDisputeRequest.
 * Use `create(GetDisputeRequestSchema)` to create a new message.
 */
export const GetDisputeRequestSchema: GenMessage<GetDisputeRequest, {jsonType: GetDisputeRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_dispute_dispute, 4);

/**
 * @generated from message guardianai.v1.dispute.DisputeListResponse
 */
export type DisputeListResponse = Message<"guardianai.v1.dispute.DisputeListResponse"> & {
  /**
   * @generated from field: repeated guardianai.v1.dispute.Dispute disputes = 1;
   */
  disputes: Dispute[];

  /**
   * @generated from field: int32 total_count = 2;
   */
  totalCount: number;
};

/**
 * @generated from message guardianai.v1.dispute.DisputeListResponse
 */
export type DisputeListResponseJson = {
  /**
   * @generated from field: repeated guardianai.v1.dispute.Dispute disputes = 1;
   */
  disputes?: DisputeJson[];

  /**
   * @generated from field: int32 total_count = 2;
   */
  totalCount?: number;
};

/**
 * Describes the message guardianai.v1.dispute.DisputeListResponse.
 * Use `create(DisputeListResponseSchema)` to create a new message.
 */
export const DisputeListResponseSchema: GenMessage<DisputeListResponse, {jsonType: DisputeListResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_dispute_dispute, 5);

/**
 * @generated from message guardianai.v1.dispute.DisputeDetailResponse
 */
export type DisputeDetailResponse = Message<"guardianai.v1.dispute.DisputeDetailResponse"> & {
  /**
   * @generated from field: guardianai.v1.dispute.Dispute dispute = 1;
   */
  dispute?: Dispute;

  /**
   * @generated from field: guardianai.v1.dispute.FraudReportSummary fraud_report = 2;
   */
  fraudReport?: FraudReportSummary;

  /**
   * @generated from field: guardianai.v1.dispute.MediatorInfo mediator = 3;
   */
  mediator?: MediatorInfo;

  /**
   * @generated from field: repeated guardianai.v1.dispute.Evidence evidence = 4;
   */
  evidence: Evidence[];
};

/**
 * @generated from message guardianai.v1.dispute.DisputeDetailResponse
 */
export type DisputeDetailResponseJson = {
  /**
   * @generated from field: guardianai.v1.dispute.Dispute dispute = 1;
   */
  dispute?: DisputeJson;

  /**
   * @generated from field: guardianai.v1.dispute.FraudReportSummary fraud_report = 2;
   */
  fraudReport?: FraudReportSummaryJson;

  /**
   * @generated from field: guardianai.v1.dispute.MediatorInfo mediator = 3;
   */
  mediator?: MediatorInfoJson;

  /**
   * @generated from field: repeated guardianai.v1.dispute.Evidence evidence = 4;
   */
  evidence?: EvidenceJson[];
};

/**
 * Describes the message guardianai.v1.dispute.DisputeDetailResponse.
 * Use `create(DisputeDetailResponseSchema)` to create a new message.
 */
export const DisputeDetailResponseSchema: GenMessage<DisputeDetailResponse, {jsonType: DisputeDetailResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_dispute_dispute, 6);

/**
 * @generated from message guardianai.v1.dispute.UpdateDisputeStatusRequest
 */
export type UpdateDisputeStatusRequest = Message<"guardianai.v1.dispute.UpdateDisputeStatusRequest"> & {
  /**
   * @generated from field: string dispute_id = 1;
   */
  disputeId: string;

  /**
   * @generated from field: guardianai.v1.dispute.DisputeStatus new_status = 2;
   */
  newStatus: DisputeStatus;

  /**
   * @generated from field: string reason = 3;
   */
  reason: string;

  /**
   * @generated from field: string updated_by = 4;
   */
  updatedBy: string;

  /**
   * Alias for updated_by for frontend
   *
   * @generated from field: string updated_by_user_id = 5;
   */
  updatedByUserId: string;
};

/**
 * @generated from message guardianai.v1.dispute.UpdateDisputeStatusRequest
 */
export type UpdateDisputeStatusRequestJson = {
  /**
   * @generated from field: string dispute_id = 1;
   */
  disputeId?: string;

  /**
   * @generated from field: guardianai.v1.dispute.DisputeStatus new_status = 2;
   */
  newStatus?: DisputeStatusJson;

  /**
   * @generated from field: string reason = 3;
   */
  reason?: string;

  /**
   * @generated from field: string updated_by = 4;
   */
  updatedBy?: string;

  /**
   * Alias for updated_by for frontend
   *
   * @generated from field: string updated_by_user_id = 5;
   */
  updatedByUserId?: string;
};

/**
 * Describes the message guardianai.v1.dispute.UpdateDisputeStatusRequest.
 * Use `create(UpdateDisputeStatusRequestSchema)` to create a new message.
 */
export const UpdateDisputeStatusRequestSchema: GenMessage<UpdateDisputeStatusRequest, {jsonType: UpdateDisputeStatusRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_dispute_dispute, 7);

/**
 * @generated from message guardianai.v1.dispute.AddEvidenceRequest
 */
export type AddEvidenceRequest = Message<"guardianai.v1.dispute.AddEvidenceRequest"> & {
  /**
   * @generated from field: string dispute_id = 1;
   */
  disputeId: string;

  /**
   * @generated from field: string submitted_by = 2;
   */
  submittedBy: string;

  /**
   * @generated from field: string evidence_type = 3;
   */
  evidenceType: string;

  /**
   * @generated from field: string description = 4;
   */
  description: string;

  /**
   * @generated from field: bytes content = 5;
   */
  content: Uint8Array;

  /**
   * @generated from field: string content_type = 6;
   */
  contentType: string;
};

/**
 * @generated from message guardianai.v1.dispute.AddEvidenceRequest
 */
export type AddEvidenceRequestJson = {
  /**
   * @generated from field: string dispute_id = 1;
   */
  disputeId?: string;

  /**
   * @generated from field: string submitted_by = 2;
   */
  submittedBy?: string;

  /**
   * @generated from field: string evidence_type = 3;
   */
  evidenceType?: string;

  /**
   * @generated from field: string description = 4;
   */
  description?: string;

  /**
   * @generated from field: bytes content = 5;
   */
  content?: string;

  /**
   * @generated from field: string content_type = 6;
   */
  contentType?: string;
};

/**
 * Describes the message guardianai.v1.dispute.AddEvidenceRequest.
 * Use `create(AddEvidenceRequestSchema)` to create a new message.
 */
export const AddEvidenceRequestSchema: GenMessage<AddEvidenceRequest, {jsonType: AddEvidenceRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_dispute_dispute, 8);

/**
 * @generated from message guardianai.v1.dispute.EvidenceResponse
 */
export type EvidenceResponse = Message<"guardianai.v1.dispute.EvidenceResponse"> & {
  /**
   * @generated from field: string evidence_id = 1;
   */
  evidenceId: string;

  /**
   * @generated from field: bool success = 2;
   */
  success: boolean;

  /**
   * @generated from field: string message = 3;
   */
  message: string;
};

/**
 * @generated from message guardianai.v1.dispute.EvidenceResponse
 */
export type EvidenceResponseJson = {
  /**
   * @generated from field: string evidence_id = 1;
   */
  evidenceId?: string;

  /**
   * @generated from field: bool success = 2;
   */
  success?: boolean;

  /**
   * @generated from field: string message = 3;
   */
  message?: string;
};

/**
 * Describes the message guardianai.v1.dispute.EvidenceResponse.
 * Use `create(EvidenceResponseSchema)` to create a new message.
 */
export const EvidenceResponseSchema: GenMessage<EvidenceResponse, {jsonType: EvidenceResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_dispute_dispute, 9);

/**
 * @generated from message guardianai.v1.dispute.GetDisputeEvidenceRequest
 */
export type GetDisputeEvidenceRequest = Message<"guardianai.v1.dispute.GetDisputeEvidenceRequest"> & {
  /**
   * @generated from field: string dispute_id = 1;
   */
  disputeId: string;
};

/**
 * @generated from message guardianai.v1.dispute.GetDisputeEvidenceRequest
 */
export type GetDisputeEvidenceRequestJson = {
  /**
   * @generated from field: string dispute_id = 1;
   */
  disputeId?: string;
};

/**
 * Describes the message guardianai.v1.dispute.GetDisputeEvidenceRequest.
 * Use `create(GetDisputeEvidenceRequestSchema)` to create a new message.
 */
export const GetDisputeEvidenceRequestSchema: GenMessage<GetDisputeEvidenceRequest, {jsonType: GetDisputeEvidenceRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_dispute_dispute, 10);

/**
 * @generated from message guardianai.v1.dispute.EvidenceListResponse
 */
export type EvidenceListResponse = Message<"guardianai.v1.dispute.EvidenceListResponse"> & {
  /**
   * @generated from field: repeated guardianai.v1.dispute.Evidence evidence = 1;
   */
  evidence: Evidence[];
};

/**
 * @generated from message guardianai.v1.dispute.EvidenceListResponse
 */
export type EvidenceListResponseJson = {
  /**
   * @generated from field: repeated guardianai.v1.dispute.Evidence evidence = 1;
   */
  evidence?: EvidenceJson[];
};

/**
 * Describes the message guardianai.v1.dispute.EvidenceListResponse.
 * Use `create(EvidenceListResponseSchema)` to create a new message.
 */
export const EvidenceListResponseSchema: GenMessage<EvidenceListResponse, {jsonType: EvidenceListResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_dispute_dispute, 11);

/**
 * @generated from message guardianai.v1.dispute.ResolveDisputeRequest
 */
export type ResolveDisputeRequest = Message<"guardianai.v1.dispute.ResolveDisputeRequest"> & {
  /**
   * @generated from field: string dispute_id = 1;
   */
  disputeId: string;

  /**
   * @generated from field: string resolved_by = 2;
   */
  resolvedBy: string;

  /**
   * @generated from field: guardianai.v1.dispute.DisputeResolution resolution = 3;
   */
  resolution: DisputeResolution;

  /**
   * @generated from field: string resolution_notes = 4;
   */
  resolutionNotes: string;
};

/**
 * @generated from message guardianai.v1.dispute.ResolveDisputeRequest
 */
export type ResolveDisputeRequestJson = {
  /**
   * @generated from field: string dispute_id = 1;
   */
  disputeId?: string;

  /**
   * @generated from field: string resolved_by = 2;
   */
  resolvedBy?: string;

  /**
   * @generated from field: guardianai.v1.dispute.DisputeResolution resolution = 3;
   */
  resolution?: DisputeResolutionJson;

  /**
   * @generated from field: string resolution_notes = 4;
   */
  resolutionNotes?: string;
};

/**
 * Describes the message guardianai.v1.dispute.ResolveDisputeRequest.
 * Use `create(ResolveDisputeRequestSchema)` to create a new message.
 */
export const ResolveDisputeRequestSchema: GenMessage<ResolveDisputeRequest, {jsonType: ResolveDisputeRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_dispute_dispute, 12);

/**
 * @generated from message guardianai.v1.dispute.GetDisputeStatsRequest
 */
export type GetDisputeStatsRequest = Message<"guardianai.v1.dispute.GetDisputeStatsRequest"> & {
  /**
   * @generated from field: int64 start_time = 1;
   */
  startTime: bigint;

  /**
   * @generated from field: int64 end_time = 2;
   */
  endTime: bigint;
};

/**
 * @generated from message guardianai.v1.dispute.GetDisputeStatsRequest
 */
export type GetDisputeStatsRequestJson = {
  /**
   * @generated from field: int64 start_time = 1;
   */
  startTime?: string;

  /**
   * @generated from field: int64 end_time = 2;
   */
  endTime?: string;
};

/**
 * Describes the message guardianai.v1.dispute.GetDisputeStatsRequest.
 * Use `create(GetDisputeStatsRequestSchema)` to create a new message.
 */
export const GetDisputeStatsRequestSchema: GenMessage<GetDisputeStatsRequest, {jsonType: GetDisputeStatsRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_dispute_dispute, 13);

/**
 * @generated from message guardianai.v1.dispute.DisputeStatsResponse
 */
export type DisputeStatsResponse = Message<"guardianai.v1.dispute.DisputeStatsResponse"> & {
  /**
   * @generated from field: int32 total_disputes = 1;
   */
  totalDisputes: number;

  /**
   * @generated from field: int32 pending_disputes = 2;
   */
  pendingDisputes: number;

  /**
   * @generated from field: int32 resolved_disputes = 3;
   */
  resolvedDisputes: number;

  /**
   * Original report upheld
   *
   * @generated from field: int32 upheld_disputes = 4;
   */
  upheldDisputes: number;

  /**
   * Report overturned
   *
   * @generated from field: int32 overturned_disputes = 5;
   */
  overturnedDisputes: number;

  /**
   * @generated from field: double average_resolution_days = 6;
   */
  averageResolutionDays: number;
};

/**
 * @generated from message guardianai.v1.dispute.DisputeStatsResponse
 */
export type DisputeStatsResponseJson = {
  /**
   * @generated from field: int32 total_disputes = 1;
   */
  totalDisputes?: number;

  /**
   * @generated from field: int32 pending_disputes = 2;
   */
  pendingDisputes?: number;

  /**
   * @generated from field: int32 resolved_disputes = 3;
   */
  resolvedDisputes?: number;

  /**
   * Original report upheld
   *
   * @generated from field: int32 upheld_disputes = 4;
   */
  upheldDisputes?: number;

  /**
   * Report overturned
   *
   * @generated from field: int32 overturned_disputes = 5;
   */
  overturnedDisputes?: number;

  /**
   * @generated from field: double average_resolution_days = 6;
   */
  averageResolutionDays?: number | "NaN" | "Infinity" | "-Infinity";
};

/**
 * Describes the message guardianai.v1.dispute.DisputeStatsResponse.
 * Use `create(DisputeStatsResponseSchema)` to create a new message.
 */
export const DisputeStatsResponseSchema: GenMessage<DisputeStatsResponse, {jsonType: DisputeStatsResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_dispute_dispute, 14);

/**
 * @generated from message guardianai.v1.dispute.AssignMediatorRequest
 */
export type AssignMediatorRequest = Message<"guardianai.v1.dispute.AssignMediatorRequest"> & {
  /**
   * @generated from field: string dispute_id = 1;
   */
  disputeId: string;

  /**
   * Optional, auto-assign if empty
   *
   * @generated from field: string mediator_id = 2;
   */
  mediatorId: string;

  /**
   * @generated from field: string assigned_by = 3;
   */
  assignedBy: string;
};

/**
 * @generated from message guardianai.v1.dispute.AssignMediatorRequest
 */
export type AssignMediatorRequestJson = {
  /**
   * @generated from field: string dispute_id = 1;
   */
  disputeId?: string;

  /**
   * Optional, auto-assign if empty
   *
   * @generated from field: string mediator_id = 2;
   */
  mediatorId?: string;

  /**
   * @generated from field: string assigned_by = 3;
   */
  assignedBy?: string;
};

/**
 * Describes the message guardianai.v1.dispute.AssignMediatorRequest.
 * Use `create(AssignMediatorRequestSchema)` to create a new message.
 */
export const AssignMediatorRequestSchema: GenMessage<AssignMediatorRequest, {jsonType: AssignMediatorRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_dispute_dispute, 15);

/**
 * @generated from message guardianai.v1.dispute.MediatorAssignmentResponse
 */
export type MediatorAssignmentResponse = Message<"guardianai.v1.dispute.MediatorAssignmentResponse"> & {
  /**
   * @generated from field: string assignment_id = 1;
   */
  assignmentId: string;

  /**
   * @generated from field: string dispute_id = 2;
   */
  disputeId: string;

  /**
   * @generated from field: string mediator_id = 3;
   */
  mediatorId: string;

  /**
   * @generated from field: guardianai.v1.dispute.AssignmentStatus status = 4;
   */
  status: AssignmentStatus;

  /**
   * @generated from field: bool success = 5;
   */
  success: boolean;

  /**
   * @generated from field: string message = 6;
   */
  message: string;
};

/**
 * @generated from message guardianai.v1.dispute.MediatorAssignmentResponse
 */
export type MediatorAssignmentResponseJson = {
  /**
   * @generated from field: string assignment_id = 1;
   */
  assignmentId?: string;

  /**
   * @generated from field: string dispute_id = 2;
   */
  disputeId?: string;

  /**
   * @generated from field: string mediator_id = 3;
   */
  mediatorId?: string;

  /**
   * @generated from field: guardianai.v1.dispute.AssignmentStatus status = 4;
   */
  status?: AssignmentStatusJson;

  /**
   * @generated from field: bool success = 5;
   */
  success?: boolean;

  /**
   * @generated from field: string message = 6;
   */
  message?: string;
};

/**
 * Describes the message guardianai.v1.dispute.MediatorAssignmentResponse.
 * Use `create(MediatorAssignmentResponseSchema)` to create a new message.
 */
export const MediatorAssignmentResponseSchema: GenMessage<MediatorAssignmentResponse, {jsonType: MediatorAssignmentResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_dispute_dispute, 16);

/**
 * @generated from message guardianai.v1.dispute.GetMediatorRequest
 */
export type GetMediatorRequest = Message<"guardianai.v1.dispute.GetMediatorRequest"> & {
  /**
   * @generated from field: string dispute_id = 1;
   */
  disputeId: string;
};

/**
 * @generated from message guardianai.v1.dispute.GetMediatorRequest
 */
export type GetMediatorRequestJson = {
  /**
   * @generated from field: string dispute_id = 1;
   */
  disputeId?: string;
};

/**
 * Describes the message guardianai.v1.dispute.GetMediatorRequest.
 * Use `create(GetMediatorRequestSchema)` to create a new message.
 */
export const GetMediatorRequestSchema: GenMessage<GetMediatorRequest, {jsonType: GetMediatorRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_dispute_dispute, 17);

/**
 * @generated from message guardianai.v1.dispute.ReassignMediatorRequest
 */
export type ReassignMediatorRequest = Message<"guardianai.v1.dispute.ReassignMediatorRequest"> & {
  /**
   * @generated from field: string dispute_id = 1;
   */
  disputeId: string;

  /**
   * @generated from field: string new_mediator_id = 2;
   */
  newMediatorId: string;

  /**
   * @generated from field: string reason = 3;
   */
  reason: string;

  /**
   * @generated from field: string reassigned_by = 4;
   */
  reassignedBy: string;
};

/**
 * @generated from message guardianai.v1.dispute.ReassignMediatorRequest
 */
export type ReassignMediatorRequestJson = {
  /**
   * @generated from field: string dispute_id = 1;
   */
  disputeId?: string;

  /**
   * @generated from field: string new_mediator_id = 2;
   */
  newMediatorId?: string;

  /**
   * @generated from field: string reason = 3;
   */
  reason?: string;

  /**
   * @generated from field: string reassigned_by = 4;
   */
  reassignedBy?: string;
};

/**
 * Describes the message guardianai.v1.dispute.ReassignMediatorRequest.
 * Use `create(ReassignMediatorRequestSchema)` to create a new message.
 */
export const ReassignMediatorRequestSchema: GenMessage<ReassignMediatorRequest, {jsonType: ReassignMediatorRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_dispute_dispute, 18);

/**
 * @generated from message guardianai.v1.dispute.GetMediatorDisputesRequest
 */
export type GetMediatorDisputesRequest = Message<"guardianai.v1.dispute.GetMediatorDisputesRequest"> & {
  /**
   * @generated from field: string mediator_id = 1;
   */
  mediatorId: string;

  /**
   * @generated from field: guardianai.v1.dispute.AssignmentStatus status_filter = 2;
   */
  statusFilter: AssignmentStatus;

  /**
   * @generated from field: int32 limit = 3;
   */
  limit: number;
};

/**
 * @generated from message guardianai.v1.dispute.GetMediatorDisputesRequest
 */
export type GetMediatorDisputesRequestJson = {
  /**
   * @generated from field: string mediator_id = 1;
   */
  mediatorId?: string;

  /**
   * @generated from field: guardianai.v1.dispute.AssignmentStatus status_filter = 2;
   */
  statusFilter?: AssignmentStatusJson;

  /**
   * @generated from field: int32 limit = 3;
   */
  limit?: number;
};

/**
 * Describes the message guardianai.v1.dispute.GetMediatorDisputesRequest.
 * Use `create(GetMediatorDisputesRequestSchema)` to create a new message.
 */
export const GetMediatorDisputesRequestSchema: GenMessage<GetMediatorDisputesRequest, {jsonType: GetMediatorDisputesRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_dispute_dispute, 19);

/**
 * @generated from message guardianai.v1.dispute.MediatorResponseRequest
 */
export type MediatorResponseRequest = Message<"guardianai.v1.dispute.MediatorResponseRequest"> & {
  /**
   * @generated from field: string assignment_id = 1;
   */
  assignmentId: string;

  /**
   * @generated from field: string mediator_id = 2;
   */
  mediatorId: string;

  /**
   * @generated from field: bool accept = 3;
   */
  accept: boolean;

  /**
   * @generated from field: string decline_reason = 4;
   */
  declineReason: string;
};

/**
 * @generated from message guardianai.v1.dispute.MediatorResponseRequest
 */
export type MediatorResponseRequestJson = {
  /**
   * @generated from field: string assignment_id = 1;
   */
  assignmentId?: string;

  /**
   * @generated from field: string mediator_id = 2;
   */
  mediatorId?: string;

  /**
   * @generated from field: bool accept = 3;
   */
  accept?: boolean;

  /**
   * @generated from field: string decline_reason = 4;
   */
  declineReason?: string;
};

/**
 * Describes the message guardianai.v1.dispute.MediatorResponseRequest.
 * Use `create(MediatorResponseRequestSchema)` to create a new message.
 */
export const MediatorResponseRequestSchema: GenMessage<MediatorResponseRequest, {jsonType: MediatorResponseRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_dispute_dispute, 20);

/**
 * @generated from message guardianai.v1.dispute.GetMediatorsRequest
 */
export type GetMediatorsRequest = Message<"guardianai.v1.dispute.GetMediatorsRequest"> & {
  /**
   * @generated from field: int32 limit = 1;
   */
  limit: number;
};

/**
 * @generated from message guardianai.v1.dispute.GetMediatorsRequest
 */
export type GetMediatorsRequestJson = {
  /**
   * @generated from field: int32 limit = 1;
   */
  limit?: number;
};

/**
 * Describes the message guardianai.v1.dispute.GetMediatorsRequest.
 * Use `create(GetMediatorsRequestSchema)` to create a new message.
 */
export const GetMediatorsRequestSchema: GenMessage<GetMediatorsRequest, {jsonType: GetMediatorsRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_dispute_dispute, 21);

/**
 * @generated from message guardianai.v1.dispute.MediatorListResponse
 */
export type MediatorListResponse = Message<"guardianai.v1.dispute.MediatorListResponse"> & {
  /**
   * @generated from field: repeated guardianai.v1.dispute.MediatorInfo mediators = 1;
   */
  mediators: MediatorInfo[];
};

/**
 * @generated from message guardianai.v1.dispute.MediatorListResponse
 */
export type MediatorListResponseJson = {
  /**
   * @generated from field: repeated guardianai.v1.dispute.MediatorInfo mediators = 1;
   */
  mediators?: MediatorInfoJson[];
};

/**
 * Describes the message guardianai.v1.dispute.MediatorListResponse.
 * Use `create(MediatorListResponseSchema)` to create a new message.
 */
export const MediatorListResponseSchema: GenMessage<MediatorListResponse, {jsonType: MediatorListResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_dispute_dispute, 22);

/**
 * @generated from message guardianai.v1.dispute.GetDashboardRequest
 */
export type GetDashboardRequest = Message<"guardianai.v1.dispute.GetDashboardRequest"> & {
  /**
   * @generated from field: string admin_id = 1;
   */
  adminId: string;

  /**
   * @generated from field: int64 start_time = 2;
   */
  startTime: bigint;

  /**
   * @generated from field: int64 end_time = 3;
   */
  endTime: bigint;
};

/**
 * @generated from message guardianai.v1.dispute.GetDashboardRequest
 */
export type GetDashboardRequestJson = {
  /**
   * @generated from field: string admin_id = 1;
   */
  adminId?: string;

  /**
   * @generated from field: int64 start_time = 2;
   */
  startTime?: string;

  /**
   * @generated from field: int64 end_time = 3;
   */
  endTime?: string;
};

/**
 * Describes the message guardianai.v1.dispute.GetDashboardRequest.
 * Use `create(GetDashboardRequestSchema)` to create a new message.
 */
export const GetDashboardRequestSchema: GenMessage<GetDashboardRequest, {jsonType: GetDashboardRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_dispute_dispute, 23);

/**
 * @generated from message guardianai.v1.dispute.DashboardResponse
 */
export type DashboardResponse = Message<"guardianai.v1.dispute.DashboardResponse"> & {
  /**
   * @generated from field: guardianai.v1.dispute.DashboardStats stats = 1;
   */
  stats?: DashboardStats;

  /**
   * @generated from field: repeated guardianai.v1.dispute.RecentActivity recent_activity = 2;
   */
  recentActivity: RecentActivity[];

  /**
   * @generated from field: repeated guardianai.v1.dispute.Alert alerts = 3;
   */
  alerts: Alert[];
};

/**
 * @generated from message guardianai.v1.dispute.DashboardResponse
 */
export type DashboardResponseJson = {
  /**
   * @generated from field: guardianai.v1.dispute.DashboardStats stats = 1;
   */
  stats?: DashboardStatsJson;

  /**
   * @generated from field: repeated guardianai.v1.dispute.RecentActivity recent_activity = 2;
   */
  recentActivity?: RecentActivityJson[];

  /**
   * @generated from field: repeated guardianai.v1.dispute.Alert alerts = 3;
   */
  alerts?: AlertJson[];
};

/**
 * Describes the message guardianai.v1.dispute.DashboardResponse.
 * Use `create(DashboardResponseSchema)` to create a new message.
 */
export const DashboardResponseSchema: GenMessage<DashboardResponse, {jsonType: DashboardResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_dispute_dispute, 24);

/**
 * @generated from message guardianai.v1.dispute.DisputeAnalyticsRequest
 */
export type DisputeAnalyticsRequest = Message<"guardianai.v1.dispute.DisputeAnalyticsRequest"> & {
  /**
   * @generated from field: int64 start_time = 1;
   */
  startTime: bigint;

  /**
   * @generated from field: int64 end_time = 2;
   */
  endTime: bigint;

  /**
   * "day", "week", "month"
   *
   * @generated from field: string group_by = 3;
   */
  groupBy: string;
};

/**
 * @generated from message guardianai.v1.dispute.DisputeAnalyticsRequest
 */
export type DisputeAnalyticsRequestJson = {
  /**
   * @generated from field: int64 start_time = 1;
   */
  startTime?: string;

  /**
   * @generated from field: int64 end_time = 2;
   */
  endTime?: string;

  /**
   * "day", "week", "month"
   *
   * @generated from field: string group_by = 3;
   */
  groupBy?: string;
};

/**
 * Describes the message guardianai.v1.dispute.DisputeAnalyticsRequest.
 * Use `create(DisputeAnalyticsRequestSchema)` to create a new message.
 */
export const DisputeAnalyticsRequestSchema: GenMessage<DisputeAnalyticsRequest, {jsonType: DisputeAnalyticsRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_dispute_dispute, 25);

/**
 * @generated from message guardianai.v1.dispute.DisputeAnalyticsResponse
 */
export type DisputeAnalyticsResponse = Message<"guardianai.v1.dispute.DisputeAnalyticsResponse"> & {
  /**
   * @generated from field: repeated guardianai.v1.dispute.TimeSeriesData dispute_trends = 1;
   */
  disputeTrends: TimeSeriesData[];

  /**
   * @generated from field: map<string, int32> by_status = 2;
   */
  byStatus: { [key: string]: number };

  /**
   * @generated from field: map<string, int32> by_resolution = 3;
   */
  byResolution: { [key: string]: number };

  /**
   * @generated from field: double avg_resolution_time_hours = 4;
   */
  avgResolutionTimeHours: number;
};

/**
 * @generated from message guardianai.v1.dispute.DisputeAnalyticsResponse
 */
export type DisputeAnalyticsResponseJson = {
  /**
   * @generated from field: repeated guardianai.v1.dispute.TimeSeriesData dispute_trends = 1;
   */
  disputeTrends?: TimeSeriesDataJson[];

  /**
   * @generated from field: map<string, int32> by_status = 2;
   */
  byStatus?: { [key: string]: number };

  /**
   * @generated from field: map<string, int32> by_resolution = 3;
   */
  byResolution?: { [key: string]: number };

  /**
   * @generated from field: double avg_resolution_time_hours = 4;
   */
  avgResolutionTimeHours?: number | "NaN" | "Infinity" | "-Infinity";
};

/**
 * Describes the message guardianai.v1.dispute.DisputeAnalyticsResponse.
 * Use `create(DisputeAnalyticsResponseSchema)` to create a new message.
 */
export const DisputeAnalyticsResponseSchema: GenMessage<DisputeAnalyticsResponse, {jsonType: DisputeAnalyticsResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_dispute_dispute, 26);

/**
 * @generated from message guardianai.v1.dispute.FraudAnalyticsRequest
 */
export type FraudAnalyticsRequest = Message<"guardianai.v1.dispute.FraudAnalyticsRequest"> & {
  /**
   * @generated from field: int64 start_time = 1;
   */
  startTime: bigint;

  /**
   * @generated from field: int64 end_time = 2;
   */
  endTime: bigint;
};

/**
 * @generated from message guardianai.v1.dispute.FraudAnalyticsRequest
 */
export type FraudAnalyticsRequestJson = {
  /**
   * @generated from field: int64 start_time = 1;
   */
  startTime?: string;

  /**
   * @generated from field: int64 end_time = 2;
   */
  endTime?: string;
};

/**
 * Describes the message guardianai.v1.dispute.FraudAnalyticsRequest.
 * Use `create(FraudAnalyticsRequestSchema)` to create a new message.
 */
export const FraudAnalyticsRequestSchema: GenMessage<FraudAnalyticsRequest, {jsonType: FraudAnalyticsRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_dispute_dispute, 27);

/**
 * @generated from message guardianai.v1.dispute.FraudAnalyticsResponse
 */
export type FraudAnalyticsResponse = Message<"guardianai.v1.dispute.FraudAnalyticsResponse"> & {
  /**
   * @generated from field: int32 total_reports = 1;
   */
  totalReports: number;

  /**
   * @generated from field: int32 confirmed_fraud = 2;
   */
  confirmedFraud: number;

  /**
   * @generated from field: double average_trust_score_impact = 3;
   */
  averageTrustScoreImpact: number;

  /**
   * @generated from field: map<string, int32> by_category = 4;
   */
  byCategory: { [key: string]: number };

  /**
   * @generated from field: repeated guardianai.v1.dispute.TimeSeriesData trends = 5;
   */
  trends: TimeSeriesData[];
};

/**
 * @generated from message guardianai.v1.dispute.FraudAnalyticsResponse
 */
export type FraudAnalyticsResponseJson = {
  /**
   * @generated from field: int32 total_reports = 1;
   */
  totalReports?: number;

  /**
   * @generated from field: int32 confirmed_fraud = 2;
   */
  confirmedFraud?: number;

  /**
   * @generated from field: double average_trust_score_impact = 3;
   */
  averageTrustScoreImpact?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: map<string, int32> by_category = 4;
   */
  byCategory?: { [key: string]: number };

  /**
   * @generated from field: repeated guardianai.v1.dispute.TimeSeriesData trends = 5;
   */
  trends?: TimeSeriesDataJson[];
};

/**
 * Describes the message guardianai.v1.dispute.FraudAnalyticsResponse.
 * Use `create(FraudAnalyticsResponseSchema)` to create a new message.
 */
export const FraudAnalyticsResponseSchema: GenMessage<FraudAnalyticsResponse, {jsonType: FraudAnalyticsResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_dispute_dispute, 28);

/**
 * @generated from message guardianai.v1.dispute.UserAnalyticsRequest
 */
export type UserAnalyticsRequest = Message<"guardianai.v1.dispute.UserAnalyticsRequest"> & {
  /**
   * @generated from field: int64 start_time = 1;
   */
  startTime: bigint;

  /**
   * @generated from field: int64 end_time = 2;
   */
  endTime: bigint;
};

/**
 * @generated from message guardianai.v1.dispute.UserAnalyticsRequest
 */
export type UserAnalyticsRequestJson = {
  /**
   * @generated from field: int64 start_time = 1;
   */
  startTime?: string;

  /**
   * @generated from field: int64 end_time = 2;
   */
  endTime?: string;
};

/**
 * Describes the message guardianai.v1.dispute.UserAnalyticsRequest.
 * Use `create(UserAnalyticsRequestSchema)` to create a new message.
 */
export const UserAnalyticsRequestSchema: GenMessage<UserAnalyticsRequest, {jsonType: UserAnalyticsRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_dispute_dispute, 29);

/**
 * @generated from message guardianai.v1.dispute.UserAnalyticsResponse
 */
export type UserAnalyticsResponse = Message<"guardianai.v1.dispute.UserAnalyticsResponse"> & {
  /**
   * @generated from field: int32 total_users = 1;
   */
  totalUsers: number;

  /**
   * @generated from field: int32 active_users = 2;
   */
  activeUsers: number;

  /**
   * @generated from field: int32 new_users = 3;
   */
  newUsers: number;

  /**
   * @generated from field: map<string, int32> by_subscription = 4;
   */
  bySubscription: { [key: string]: number };
};

/**
 * @generated from message guardianai.v1.dispute.UserAnalyticsResponse
 */
export type UserAnalyticsResponseJson = {
  /**
   * @generated from field: int32 total_users = 1;
   */
  totalUsers?: number;

  /**
   * @generated from field: int32 active_users = 2;
   */
  activeUsers?: number;

  /**
   * @generated from field: int32 new_users = 3;
   */
  newUsers?: number;

  /**
   * @generated from field: map<string, int32> by_subscription = 4;
   */
  bySubscription?: { [key: string]: number };
};

/**
 * Describes the message guardianai.v1.dispute.UserAnalyticsResponse.
 * Use `create(UserAnalyticsResponseSchema)` to create a new message.
 */
export const UserAnalyticsResponseSchema: GenMessage<UserAnalyticsResponse, {jsonType: UserAnalyticsResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_dispute_dispute, 30);

/**
 * @generated from message guardianai.v1.dispute.SystemHealthRequest
 */
export type SystemHealthRequest = Message<"guardianai.v1.dispute.SystemHealthRequest"> & {
};

/**
 * @generated from message guardianai.v1.dispute.SystemHealthRequest
 */
export type SystemHealthRequestJson = {
};

/**
 * Describes the message guardianai.v1.dispute.SystemHealthRequest.
 * Use `create(SystemHealthRequestSchema)` to create a new message.
 */
export const SystemHealthRequestSchema: GenMessage<SystemHealthRequest, {jsonType: SystemHealthRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_dispute_dispute, 31);

/**
 * @generated from message guardianai.v1.dispute.SystemHealthResponse
 */
export type SystemHealthResponse = Message<"guardianai.v1.dispute.SystemHealthResponse"> & {
  /**
   * "healthy", "degraded", "unhealthy"
   *
   * @generated from field: string status = 1;
   */
  status: string;

  /**
   * @generated from field: double cpu_usage = 2;
   */
  cpuUsage: number;

  /**
   * @generated from field: double memory_usage = 3;
   */
  memoryUsage: number;

  /**
   * @generated from field: double disk_usage = 4;
   */
  diskUsage: number;

  /**
   * @generated from field: int32 active_connections = 5;
   */
  activeConnections: number;

  /**
   * @generated from field: double avg_response_time_ms = 6;
   */
  avgResponseTimeMs: number;

  /**
   * @generated from field: repeated guardianai.v1.dispute.ServiceHealth services = 7;
   */
  services: ServiceHealth[];
};

/**
 * @generated from message guardianai.v1.dispute.SystemHealthResponse
 */
export type SystemHealthResponseJson = {
  /**
   * "healthy", "degraded", "unhealthy"
   *
   * @generated from field: string status = 1;
   */
  status?: string;

  /**
   * @generated from field: double cpu_usage = 2;
   */
  cpuUsage?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: double memory_usage = 3;
   */
  memoryUsage?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: double disk_usage = 4;
   */
  diskUsage?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: int32 active_connections = 5;
   */
  activeConnections?: number;

  /**
   * @generated from field: double avg_response_time_ms = 6;
   */
  avgResponseTimeMs?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: repeated guardianai.v1.dispute.ServiceHealth services = 7;
   */
  services?: ServiceHealthJson[];
};

/**
 * Describes the message guardianai.v1.dispute.SystemHealthResponse.
 * Use `create(SystemHealthResponseSchema)` to create a new message.
 */
export const SystemHealthResponseSchema: GenMessage<SystemHealthResponse, {jsonType: SystemHealthResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_dispute_dispute, 32);

/**
 * @generated from message guardianai.v1.dispute.AuditTrailRequest
 */
export type AuditTrailRequest = Message<"guardianai.v1.dispute.AuditTrailRequest"> & {
  /**
   * "dispute", "user", "report"
   *
   * @generated from field: string entity_type = 1;
   */
  entityType: string;

  /**
   * @generated from field: string entity_id = 2;
   */
  entityId: string;

  /**
   * @generated from field: int32 limit = 3;
   */
  limit: number;
};

/**
 * @generated from message guardianai.v1.dispute.AuditTrailRequest
 */
export type AuditTrailRequestJson = {
  /**
   * "dispute", "user", "report"
   *
   * @generated from field: string entity_type = 1;
   */
  entityType?: string;

  /**
   * @generated from field: string entity_id = 2;
   */
  entityId?: string;

  /**
   * @generated from field: int32 limit = 3;
   */
  limit?: number;
};

/**
 * Describes the message guardianai.v1.dispute.AuditTrailRequest.
 * Use `create(AuditTrailRequestSchema)` to create a new message.
 */
export const AuditTrailRequestSchema: GenMessage<AuditTrailRequest, {jsonType: AuditTrailRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_dispute_dispute, 33);

/**
 * @generated from message guardianai.v1.dispute.AuditTrailResponse
 */
export type AuditTrailResponse = Message<"guardianai.v1.dispute.AuditTrailResponse"> & {
  /**
   * @generated from field: repeated guardianai.v1.dispute.AuditEntry entries = 1;
   */
  entries: AuditEntry[];
};

/**
 * @generated from message guardianai.v1.dispute.AuditTrailResponse
 */
export type AuditTrailResponseJson = {
  /**
   * @generated from field: repeated guardianai.v1.dispute.AuditEntry entries = 1;
   */
  entries?: AuditEntryJson[];
};

/**
 * Describes the message guardianai.v1.dispute.AuditTrailResponse.
 * Use `create(AuditTrailResponseSchema)` to create a new message.
 */
export const AuditTrailResponseSchema: GenMessage<AuditTrailResponse, {jsonType: AuditTrailResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_dispute_dispute, 34);

/**
 * @generated from message guardianai.v1.dispute.Dispute
 */
export type Dispute = Message<"guardianai.v1.dispute.Dispute"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string fraud_report_id = 2;
   */
  fraudReportId: string;

  /**
   * @generated from field: string disputant_id = 3;
   */
  disputantId: string;

  /**
   * @generated from field: string reason = 4;
   */
  reason: string;

  /**
   * @generated from field: string description = 5;
   */
  description: string;

  /**
   * @generated from field: guardianai.v1.dispute.DisputeStatus status = 6;
   */
  status: DisputeStatus;

  /**
   * @generated from field: int64 created_at = 7;
   */
  createdAt: bigint;

  /**
   * @generated from field: int64 updated_at = 8;
   */
  updatedAt: bigint;

  /**
   * @generated from field: string mediator_id = 9;
   */
  mediatorId: string;

  /**
   * @generated from field: guardianai.v1.dispute.DisputeResolution resolution = 10;
   */
  resolution: DisputeResolution;

  /**
   * @generated from field: string resolution_notes = 11;
   */
  resolutionNotes: string;

  /**
   * @generated from field: int64 resolved_at = 12;
   */
  resolvedAt: bigint;

  /**
   * Additional fields for frontend compatibility
   *
   * Alias for id
   *
   * @generated from field: string dispute_id = 13;
   */
  disputeId: string;

  /**
   * @generated from field: string category = 14;
   */
  category: string;

  /**
   * @generated from field: string priority = 15;
   */
  priority: string;

  /**
   * User who initiated the dispute
   *
   * @generated from field: string initiator_user_id = 16;
   */
  initiatorUserId: string;

  /**
   * User being disputed against
   *
   * @generated from field: string counterparty_user_id = 17;
   */
  counterpartyUserId: string;

  /**
   * Different from mediator_id for assignment tracking
   *
   * @generated from field: string assigned_mediator_id = 18;
   */
  assignedMediatorId: string;

  /**
   * @generated from field: repeated string attachment_urls = 19;
   */
  attachmentUrls: string[];

  /**
   * @generated from field: repeated guardianai.v1.dispute.DisputeComment comments = 20;
   */
  comments: DisputeComment[];

  /**
   * @generated from field: string evidence_description = 21;
   */
  evidenceDescription: string;

  /**
   * @generated from field: string resolution_details = 22;
   */
  resolutionDetails: string;

  /**
   * @generated from field: string outcome = 23;
   */
  outcome: string;
};

/**
 * @generated from message guardianai.v1.dispute.Dispute
 */
export type DisputeJson = {
  /**
   * @generated from field: string id = 1;
   */
  id?: string;

  /**
   * @generated from field: string fraud_report_id = 2;
   */
  fraudReportId?: string;

  /**
   * @generated from field: string disputant_id = 3;
   */
  disputantId?: string;

  /**
   * @generated from field: string reason = 4;
   */
  reason?: string;

  /**
   * @generated from field: string description = 5;
   */
  description?: string;

  /**
   * @generated from field: guardianai.v1.dispute.DisputeStatus status = 6;
   */
  status?: DisputeStatusJson;

  /**
   * @generated from field: int64 created_at = 7;
   */
  createdAt?: string;

  /**
   * @generated from field: int64 updated_at = 8;
   */
  updatedAt?: string;

  /**
   * @generated from field: string mediator_id = 9;
   */
  mediatorId?: string;

  /**
   * @generated from field: guardianai.v1.dispute.DisputeResolution resolution = 10;
   */
  resolution?: DisputeResolutionJson;

  /**
   * @generated from field: string resolution_notes = 11;
   */
  resolutionNotes?: string;

  /**
   * @generated from field: int64 resolved_at = 12;
   */
  resolvedAt?: string;

  /**
   * Additional fields for frontend compatibility
   *
   * Alias for id
   *
   * @generated from field: string dispute_id = 13;
   */
  disputeId?: string;

  /**
   * @generated from field: string category = 14;
   */
  category?: string;

  /**
   * @generated from field: string priority = 15;
   */
  priority?: string;

  /**
   * User who initiated the dispute
   *
   * @generated from field: string initiator_user_id = 16;
   */
  initiatorUserId?: string;

  /**
   * User being disputed against
   *
   * @generated from field: string counterparty_user_id = 17;
   */
  counterpartyUserId?: string;

  /**
   * Different from mediator_id for assignment tracking
   *
   * @generated from field: string assigned_mediator_id = 18;
   */
  assignedMediatorId?: string;

  /**
   * @generated from field: repeated string attachment_urls = 19;
   */
  attachmentUrls?: string[];

  /**
   * @generated from field: repeated guardianai.v1.dispute.DisputeComment comments = 20;
   */
  comments?: DisputeCommentJson[];

  /**
   * @generated from field: string evidence_description = 21;
   */
  evidenceDescription?: string;

  /**
   * @generated from field: string resolution_details = 22;
   */
  resolutionDetails?: string;

  /**
   * @generated from field: string outcome = 23;
   */
  outcome?: string;
};

/**
 * Describes the message guardianai.v1.dispute.Dispute.
 * Use `create(DisputeSchema)` to create a new message.
 */
export const DisputeSchema: GenMessage<Dispute, {jsonType: DisputeJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_dispute_dispute, 35);

/**
 * @generated from message guardianai.v1.dispute.DisputeComment
 */
export type DisputeComment = Message<"guardianai.v1.dispute.DisputeComment"> & {
  /**
   * @generated from field: string comment_id = 1;
   */
  commentId: string;

  /**
   * @generated from field: string user_id = 2;
   */
  userId: string;

  /**
   * @generated from field: string content = 3;
   */
  content: string;

  /**
   * @generated from field: int64 created_at = 4;
   */
  createdAt: bigint;
};

/**
 * @generated from message guardianai.v1.dispute.DisputeComment
 */
export type DisputeCommentJson = {
  /**
   * @generated from field: string comment_id = 1;
   */
  commentId?: string;

  /**
   * @generated from field: string user_id = 2;
   */
  userId?: string;

  /**
   * @generated from field: string content = 3;
   */
  content?: string;

  /**
   * @generated from field: int64 created_at = 4;
   */
  createdAt?: string;
};

/**
 * Describes the message guardianai.v1.dispute.DisputeComment.
 * Use `create(DisputeCommentSchema)` to create a new message.
 */
export const DisputeCommentSchema: GenMessage<DisputeComment, {jsonType: DisputeCommentJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_dispute_dispute, 36);

/**
 * @generated from message guardianai.v1.dispute.Evidence
 */
export type Evidence = Message<"guardianai.v1.dispute.Evidence"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string dispute_id = 2;
   */
  disputeId: string;

  /**
   * @generated from field: string submitted_by = 3;
   */
  submittedBy: string;

  /**
   * @generated from field: string evidence_type = 4;
   */
  evidenceType: string;

  /**
   * @generated from field: string description = 5;
   */
  description: string;

  /**
   * @generated from field: string file_url = 6;
   */
  fileUrl: string;

  /**
   * @generated from field: string content_type = 7;
   */
  contentType: string;

  /**
   * @generated from field: int64 submitted_at = 8;
   */
  submittedAt: bigint;
};

/**
 * @generated from message guardianai.v1.dispute.Evidence
 */
export type EvidenceJson = {
  /**
   * @generated from field: string id = 1;
   */
  id?: string;

  /**
   * @generated from field: string dispute_id = 2;
   */
  disputeId?: string;

  /**
   * @generated from field: string submitted_by = 3;
   */
  submittedBy?: string;

  /**
   * @generated from field: string evidence_type = 4;
   */
  evidenceType?: string;

  /**
   * @generated from field: string description = 5;
   */
  description?: string;

  /**
   * @generated from field: string file_url = 6;
   */
  fileUrl?: string;

  /**
   * @generated from field: string content_type = 7;
   */
  contentType?: string;

  /**
   * @generated from field: int64 submitted_at = 8;
   */
  submittedAt?: string;
};

/**
 * Describes the message guardianai.v1.dispute.Evidence.
 * Use `create(EvidenceSchema)` to create a new message.
 */
export const EvidenceSchema: GenMessage<Evidence, {jsonType: EvidenceJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_dispute_dispute, 37);

/**
 * @generated from message guardianai.v1.dispute.FraudReportSummary
 */
export type FraudReportSummary = Message<"guardianai.v1.dispute.FraudReportSummary"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string title = 2;
   */
  title: string;

  /**
   * @generated from field: string status = 3;
   */
  status: string;

  /**
   * @generated from field: int64 created_at = 4;
   */
  createdAt: bigint;

  /**
   * @generated from field: string reporter_id = 5;
   */
  reporterId: string;
};

/**
 * @generated from message guardianai.v1.dispute.FraudReportSummary
 */
export type FraudReportSummaryJson = {
  /**
   * @generated from field: string id = 1;
   */
  id?: string;

  /**
   * @generated from field: string title = 2;
   */
  title?: string;

  /**
   * @generated from field: string status = 3;
   */
  status?: string;

  /**
   * @generated from field: int64 created_at = 4;
   */
  createdAt?: string;

  /**
   * @generated from field: string reporter_id = 5;
   */
  reporterId?: string;
};

/**
 * Describes the message guardianai.v1.dispute.FraudReportSummary.
 * Use `create(FraudReportSummarySchema)` to create a new message.
 */
export const FraudReportSummarySchema: GenMessage<FraudReportSummary, {jsonType: FraudReportSummaryJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_dispute_dispute, 38);

/**
 * @generated from message guardianai.v1.dispute.MediatorInfo
 */
export type MediatorInfo = Message<"guardianai.v1.dispute.MediatorInfo"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string email = 3;
   */
  email: string;

  /**
   * @generated from field: int32 active_cases = 4;
   */
  activeCases: number;

  /**
   * @generated from field: int32 resolved_cases = 5;
   */
  resolvedCases: number;

  /**
   * @generated from field: double success_rate = 6;
   */
  successRate: number;

  /**
   * @generated from field: bool available = 7;
   */
  available: boolean;
};

/**
 * @generated from message guardianai.v1.dispute.MediatorInfo
 */
export type MediatorInfoJson = {
  /**
   * @generated from field: string id = 1;
   */
  id?: string;

  /**
   * @generated from field: string name = 2;
   */
  name?: string;

  /**
   * @generated from field: string email = 3;
   */
  email?: string;

  /**
   * @generated from field: int32 active_cases = 4;
   */
  activeCases?: number;

  /**
   * @generated from field: int32 resolved_cases = 5;
   */
  resolvedCases?: number;

  /**
   * @generated from field: double success_rate = 6;
   */
  successRate?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: bool available = 7;
   */
  available?: boolean;
};

/**
 * Describes the message guardianai.v1.dispute.MediatorInfo.
 * Use `create(MediatorInfoSchema)` to create a new message.
 */
export const MediatorInfoSchema: GenMessage<MediatorInfo, {jsonType: MediatorInfoJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_dispute_dispute, 39);

/**
 * @generated from message guardianai.v1.dispute.DashboardStats
 */
export type DashboardStats = Message<"guardianai.v1.dispute.DashboardStats"> & {
  /**
   * @generated from field: int32 total_users = 1;
   */
  totalUsers: number;

  /**
   * @generated from field: int32 active_disputes = 2;
   */
  activeDisputes: number;

  /**
   * @generated from field: int32 pending_reports = 3;
   */
  pendingReports: number;

  /**
   * @generated from field: int32 resolved_today = 4;
   */
  resolvedToday: number;

  /**
   * @generated from field: double system_health_score = 5;
   */
  systemHealthScore: number;
};

/**
 * @generated from message guardianai.v1.dispute.DashboardStats
 */
export type DashboardStatsJson = {
  /**
   * @generated from field: int32 total_users = 1;
   */
  totalUsers?: number;

  /**
   * @generated from field: int32 active_disputes = 2;
   */
  activeDisputes?: number;

  /**
   * @generated from field: int32 pending_reports = 3;
   */
  pendingReports?: number;

  /**
   * @generated from field: int32 resolved_today = 4;
   */
  resolvedToday?: number;

  /**
   * @generated from field: double system_health_score = 5;
   */
  systemHealthScore?: number | "NaN" | "Infinity" | "-Infinity";
};

/**
 * Describes the message guardianai.v1.dispute.DashboardStats.
 * Use `create(DashboardStatsSchema)` to create a new message.
 */
export const DashboardStatsSchema: GenMessage<DashboardStats, {jsonType: DashboardStatsJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_dispute_dispute, 40);

/**
 * @generated from message guardianai.v1.dispute.RecentActivity
 */
export type RecentActivity = Message<"guardianai.v1.dispute.RecentActivity"> & {
  /**
   * @generated from field: string type = 1;
   */
  type: string;

  /**
   * @generated from field: string description = 2;
   */
  description: string;

  /**
   * @generated from field: string actor_id = 3;
   */
  actorId: string;

  /**
   * @generated from field: int64 timestamp = 4;
   */
  timestamp: bigint;
};

/**
 * @generated from message guardianai.v1.dispute.RecentActivity
 */
export type RecentActivityJson = {
  /**
   * @generated from field: string type = 1;
   */
  type?: string;

  /**
   * @generated from field: string description = 2;
   */
  description?: string;

  /**
   * @generated from field: string actor_id = 3;
   */
  actorId?: string;

  /**
   * @generated from field: int64 timestamp = 4;
   */
  timestamp?: string;
};

/**
 * Describes the message guardianai.v1.dispute.RecentActivity.
 * Use `create(RecentActivitySchema)` to create a new message.
 */
export const RecentActivitySchema: GenMessage<RecentActivity, {jsonType: RecentActivityJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_dispute_dispute, 41);

/**
 * @generated from message guardianai.v1.dispute.Alert
 */
export type Alert = Message<"guardianai.v1.dispute.Alert"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string severity = 2;
   */
  severity: string;

  /**
   * @generated from field: string message = 3;
   */
  message: string;

  /**
   * @generated from field: int64 created_at = 4;
   */
  createdAt: bigint;
};

/**
 * @generated from message guardianai.v1.dispute.Alert
 */
export type AlertJson = {
  /**
   * @generated from field: string id = 1;
   */
  id?: string;

  /**
   * @generated from field: string severity = 2;
   */
  severity?: string;

  /**
   * @generated from field: string message = 3;
   */
  message?: string;

  /**
   * @generated from field: int64 created_at = 4;
   */
  createdAt?: string;
};

/**
 * Describes the message guardianai.v1.dispute.Alert.
 * Use `create(AlertSchema)` to create a new message.
 */
export const AlertSchema: GenMessage<Alert, {jsonType: AlertJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_dispute_dispute, 42);

/**
 * @generated from message guardianai.v1.dispute.TimeSeriesData
 */
export type TimeSeriesData = Message<"guardianai.v1.dispute.TimeSeriesData"> & {
  /**
   * @generated from field: int64 timestamp = 1;
   */
  timestamp: bigint;

  /**
   * @generated from field: double value = 2;
   */
  value: number;

  /**
   * @generated from field: string label = 3;
   */
  label: string;
};

/**
 * @generated from message guardianai.v1.dispute.TimeSeriesData
 */
export type TimeSeriesDataJson = {
  /**
   * @generated from field: int64 timestamp = 1;
   */
  timestamp?: string;

  /**
   * @generated from field: double value = 2;
   */
  value?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: string label = 3;
   */
  label?: string;
};

/**
 * Describes the message guardianai.v1.dispute.TimeSeriesData.
 * Use `create(TimeSeriesDataSchema)` to create a new message.
 */
export const TimeSeriesDataSchema: GenMessage<TimeSeriesData, {jsonType: TimeSeriesDataJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_dispute_dispute, 43);

/**
 * @generated from message guardianai.v1.dispute.ServiceHealth
 */
export type ServiceHealth = Message<"guardianai.v1.dispute.ServiceHealth"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: string status = 2;
   */
  status: string;

  /**
   * @generated from field: double latency_ms = 3;
   */
  latencyMs: number;

  /**
   * @generated from field: int64 last_check = 4;
   */
  lastCheck: bigint;
};

/**
 * @generated from message guardianai.v1.dispute.ServiceHealth
 */
export type ServiceHealthJson = {
  /**
   * @generated from field: string name = 1;
   */
  name?: string;

  /**
   * @generated from field: string status = 2;
   */
  status?: string;

  /**
   * @generated from field: double latency_ms = 3;
   */
  latencyMs?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: int64 last_check = 4;
   */
  lastCheck?: string;
};

/**
 * Describes the message guardianai.v1.dispute.ServiceHealth.
 * Use `create(ServiceHealthSchema)` to create a new message.
 */
export const ServiceHealthSchema: GenMessage<ServiceHealth, {jsonType: ServiceHealthJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_dispute_dispute, 44);

/**
 * @generated from message guardianai.v1.dispute.AuditEntry
 */
export type AuditEntry = Message<"guardianai.v1.dispute.AuditEntry"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string action = 2;
   */
  action: string;

  /**
   * @generated from field: string actor_id = 3;
   */
  actorId: string;

  /**
   * @generated from field: string entity_type = 4;
   */
  entityType: string;

  /**
   * @generated from field: string entity_id = 5;
   */
  entityId: string;

  /**
   * @generated from field: string details = 6;
   */
  details: string;

  /**
   * @generated from field: int64 timestamp = 7;
   */
  timestamp: bigint;
};

/**
 * @generated from message guardianai.v1.dispute.AuditEntry
 */
export type AuditEntryJson = {
  /**
   * @generated from field: string id = 1;
   */
  id?: string;

  /**
   * @generated from field: string action = 2;
   */
  action?: string;

  /**
   * @generated from field: string actor_id = 3;
   */
  actorId?: string;

  /**
   * @generated from field: string entity_type = 4;
   */
  entityType?: string;

  /**
   * @generated from field: string entity_id = 5;
   */
  entityId?: string;

  /**
   * @generated from field: string details = 6;
   */
  details?: string;

  /**
   * @generated from field: int64 timestamp = 7;
   */
  timestamp?: string;
};

/**
 * Describes the message guardianai.v1.dispute.AuditEntry.
 * Use `create(AuditEntrySchema)` to create a new message.
 */
export const AuditEntrySchema: GenMessage<AuditEntry, {jsonType: AuditEntryJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_dispute_dispute, 45);

/**
 * @generated from enum guardianai.v1.dispute.DisputeStatus
 */
export enum DisputeStatus {
  /**
   * @generated from enum value: DISPUTE_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: DISPUTE_STATUS_PENDING = 1;
   */
  PENDING = 1,

  /**
   * @generated from enum value: DISPUTE_STATUS_UNDER_REVIEW = 2;
   */
  UNDER_REVIEW = 2,

  /**
   * @generated from enum value: DISPUTE_STATUS_AWAITING_EVIDENCE = 3;
   */
  AWAITING_EVIDENCE = 3,

  /**
   * @generated from enum value: DISPUTE_STATUS_MEDIATION = 4;
   */
  MEDIATION = 4,

  /**
   * @generated from enum value: DISPUTE_STATUS_RESOLVED = 5;
   */
  RESOLVED = 5,

  /**
   * @generated from enum value: DISPUTE_STATUS_DISMISSED = 6;
   */
  DISMISSED = 6,

  /**
   * @generated from enum value: DISPUTE_STATUS_ESCALATED = 7;
   */
  ESCALATED = 7,
}

/**
 * @generated from enum guardianai.v1.dispute.DisputeStatus
 */
export type DisputeStatusJson = "DISPUTE_STATUS_UNSPECIFIED" | "DISPUTE_STATUS_PENDING" | "DISPUTE_STATUS_UNDER_REVIEW" | "DISPUTE_STATUS_AWAITING_EVIDENCE" | "DISPUTE_STATUS_MEDIATION" | "DISPUTE_STATUS_RESOLVED" | "DISPUTE_STATUS_DISMISSED" | "DISPUTE_STATUS_ESCALATED";

/**
 * Describes the enum guardianai.v1.dispute.DisputeStatus.
 */
export const DisputeStatusSchema: GenEnum<DisputeStatus, DisputeStatusJson> = /*@__PURE__*/
  enumDesc(file_guardianai_v1_dispute_dispute, 0);

/**
 * @generated from enum guardianai.v1.dispute.DisputeResolution
 */
export enum DisputeResolution {
  /**
   * @generated from enum value: DISPUTE_RESOLUTION_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Original fraud report stands
   *
   * @generated from enum value: DISPUTE_RESOLUTION_UPHELD = 1;
   */
  UPHELD = 1,

  /**
   * Fraud report invalidated
   *
   * @generated from enum value: DISPUTE_RESOLUTION_OVERTURNED = 2;
   */
  OVERTURNED = 2,

  /**
   * Partially upheld
   *
   * @generated from enum value: DISPUTE_RESOLUTION_PARTIAL = 3;
   */
  PARTIAL = 3,

  /**
   * Disputant withdrew
   *
   * @generated from enum value: DISPUTE_RESOLUTION_WITHDRAWN = 4;
   */
  WITHDRAWN = 4,
}

/**
 * @generated from enum guardianai.v1.dispute.DisputeResolution
 */
export type DisputeResolutionJson = "DISPUTE_RESOLUTION_UNSPECIFIED" | "DISPUTE_RESOLUTION_UPHELD" | "DISPUTE_RESOLUTION_OVERTURNED" | "DISPUTE_RESOLUTION_PARTIAL" | "DISPUTE_RESOLUTION_WITHDRAWN";

/**
 * Describes the enum guardianai.v1.dispute.DisputeResolution.
 */
export const DisputeResolutionSchema: GenEnum<DisputeResolution, DisputeResolutionJson> = /*@__PURE__*/
  enumDesc(file_guardianai_v1_dispute_dispute, 1);

/**
 * @generated from enum guardianai.v1.dispute.AssignmentStatus
 */
export enum AssignmentStatus {
  /**
   * @generated from enum value: ASSIGNMENT_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: ASSIGNMENT_STATUS_PENDING = 1;
   */
  PENDING = 1,

  /**
   * @generated from enum value: ASSIGNMENT_STATUS_ACCEPTED = 2;
   */
  ACCEPTED = 2,

  /**
   * @generated from enum value: ASSIGNMENT_STATUS_DECLINED = 3;
   */
  DECLINED = 3,

  /**
   * @generated from enum value: ASSIGNMENT_STATUS_COMPLETED = 4;
   */
  COMPLETED = 4,

  /**
   * @generated from enum value: ASSIGNMENT_STATUS_REASSIGNED = 5;
   */
  REASSIGNED = 5,
}

/**
 * @generated from enum guardianai.v1.dispute.AssignmentStatus
 */
export type AssignmentStatusJson = "ASSIGNMENT_STATUS_UNSPECIFIED" | "ASSIGNMENT_STATUS_PENDING" | "ASSIGNMENT_STATUS_ACCEPTED" | "ASSIGNMENT_STATUS_DECLINED" | "ASSIGNMENT_STATUS_COMPLETED" | "ASSIGNMENT_STATUS_REASSIGNED";

/**
 * Describes the enum guardianai.v1.dispute.AssignmentStatus.
 */
export const AssignmentStatusSchema: GenEnum<AssignmentStatus, AssignmentStatusJson> = /*@__PURE__*/
  enumDesc(file_guardianai_v1_dispute_dispute, 2);

/**
 * @generated from service guardianai.v1.dispute.DisputeService
 */
export const DisputeService: GenService<{
  /**
   * Submit a new dispute (supports multiple dispute types)
   *
   * @generated from rpc guardianai.v1.dispute.DisputeService.SubmitDispute
   */
  submitDispute: {
    methodKind: "unary";
    input: typeof DisputeRequestSchema;
    output: typeof DisputeResponseSchema;
  },
  /**
   * Get all disputes for a specific fraud report
   *
   * @generated from rpc guardianai.v1.dispute.DisputeService.GetDisputesForReport
   */
  getDisputesForReport: {
    methodKind: "unary";
    input: typeof GetDisputesForReportRequestSchema;
    output: typeof DisputeListResponseSchema;
  },
  /**
   * Get all disputes filed by a user
   *
   * @generated from rpc guardianai.v1.dispute.DisputeService.GetUserDisputes
   */
  getUserDisputes: {
    methodKind: "unary";
    input: typeof GetUserDisputesRequestSchema;
    output: typeof DisputeListResponseSchema;
  },
  /**
   * Get a specific dispute by ID
   *
   * @generated from rpc guardianai.v1.dispute.DisputeService.GetDispute
   */
  getDispute: {
    methodKind: "unary";
    input: typeof GetDisputeRequestSchema;
    output: typeof DisputeDetailResponseSchema;
  },
  /**
   * Update dispute status (admin/mediator only)
   *
   * @generated from rpc guardianai.v1.dispute.DisputeService.UpdateDisputeStatus
   */
  updateDisputeStatus: {
    methodKind: "unary";
    input: typeof UpdateDisputeStatusRequestSchema;
    output: typeof DisputeResponseSchema;
  },
  /**
   * Add evidence to a dispute
   *
   * @generated from rpc guardianai.v1.dispute.DisputeService.AddEvidence
   */
  addEvidence: {
    methodKind: "unary";
    input: typeof AddEvidenceRequestSchema;
    output: typeof EvidenceResponseSchema;
  },
  /**
   * Get dispute evidence
   *
   * @generated from rpc guardianai.v1.dispute.DisputeService.GetDisputeEvidence
   */
  getDisputeEvidence: {
    methodKind: "unary";
    input: typeof GetDisputeEvidenceRequestSchema;
    output: typeof EvidenceListResponseSchema;
  },
  /**
   * Submit dispute resolution
   *
   * @generated from rpc guardianai.v1.dispute.DisputeService.ResolveDispute
   */
  resolveDispute: {
    methodKind: "unary";
    input: typeof ResolveDisputeRequestSchema;
    output: typeof DisputeResponseSchema;
  },
  /**
   * Get dispute statistics
   *
   * @generated from rpc guardianai.v1.dispute.DisputeService.GetDisputeStats
   */
  getDisputeStats: {
    methodKind: "unary";
    input: typeof GetDisputeStatsRequestSchema;
    output: typeof DisputeStatsResponseSchema;
  },
  /**
   * Assign dispute to mediator
   *
   * @generated from rpc guardianai.v1.dispute.DisputeService.AssignDisputeToMediator
   */
  assignDisputeToMediator: {
    methodKind: "unary";
    input: typeof AssignMediatorRequestSchema;
    output: typeof MediatorAssignmentResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_guardianai_v1_dispute_dispute, 0);

/**
 * @generated from service guardianai.v1.dispute.MediatorService
 */
export const MediatorService: GenService<{
  /**
   * Assign a mediator to a dispute
   *
   * @generated from rpc guardianai.v1.dispute.MediatorService.AssignMediator
   */
  assignMediator: {
    methodKind: "unary";
    input: typeof AssignMediatorRequestSchema;
    output: typeof MediatorAssignmentResponseSchema;
  },
  /**
   * Get mediator for a dispute
   *
   * @generated from rpc guardianai.v1.dispute.MediatorService.GetMediatorForDispute
   */
  getMediatorForDispute: {
    methodKind: "unary";
    input: typeof GetMediatorRequestSchema;
    output: typeof MediatorAssignmentResponseSchema;
  },
  /**
   * Reassign mediator
   *
   * @generated from rpc guardianai.v1.dispute.MediatorService.ReassignMediator
   */
  reassignMediator: {
    methodKind: "unary";
    input: typeof ReassignMediatorRequestSchema;
    output: typeof MediatorAssignmentResponseSchema;
  },
  /**
   * Get mediator's active disputes
   *
   * @generated from rpc guardianai.v1.dispute.MediatorService.GetMediatorDisputes
   */
  getMediatorDisputes: {
    methodKind: "unary";
    input: typeof GetMediatorDisputesRequestSchema;
    output: typeof DisputeListResponseSchema;
  },
  /**
   * Mediator accepts/rejects assignment
   *
   * @generated from rpc guardianai.v1.dispute.MediatorService.RespondToAssignment
   */
  respondToAssignment: {
    methodKind: "unary";
    input: typeof MediatorResponseRequestSchema;
    output: typeof MediatorAssignmentResponseSchema;
  },
  /**
   * Get available mediators
   *
   * @generated from rpc guardianai.v1.dispute.MediatorService.GetAvailableMediators
   */
  getAvailableMediators: {
    methodKind: "unary";
    input: typeof GetMediatorsRequestSchema;
    output: typeof MediatorListResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_guardianai_v1_dispute_dispute, 1);

/**
 * @generated from service guardianai.v1.dispute.AdminDashboardService
 */
export const AdminDashboardService: GenService<{
  /**
   * Get admin dashboard overview
   *
   * @generated from rpc guardianai.v1.dispute.AdminDashboardService.GetDashboard
   */
  getDashboard: {
    methodKind: "unary";
    input: typeof GetDashboardRequestSchema;
    output: typeof DashboardResponseSchema;
  },
  /**
   * Get dispute analytics
   *
   * @generated from rpc guardianai.v1.dispute.AdminDashboardService.GetDisputeAnalytics
   */
  getDisputeAnalytics: {
    methodKind: "unary";
    input: typeof DisputeAnalyticsRequestSchema;
    output: typeof DisputeAnalyticsResponseSchema;
  },
  /**
   * Get fraud report analytics
   *
   * @generated from rpc guardianai.v1.dispute.AdminDashboardService.GetFraudReportAnalytics
   */
  getFraudReportAnalytics: {
    methodKind: "unary";
    input: typeof FraudAnalyticsRequestSchema;
    output: typeof FraudAnalyticsResponseSchema;
  },
  /**
   * Get user activity analytics
   *
   * @generated from rpc guardianai.v1.dispute.AdminDashboardService.GetUserAnalytics
   */
  getUserAnalytics: {
    methodKind: "unary";
    input: typeof UserAnalyticsRequestSchema;
    output: typeof UserAnalyticsResponseSchema;
  },
  /**
   * Get system health metrics
   *
   * @generated from rpc guardianai.v1.dispute.AdminDashboardService.GetSystemHealth
   */
  getSystemHealth: {
    methodKind: "unary";
    input: typeof SystemHealthRequestSchema;
    output: typeof SystemHealthResponseSchema;
  },
  /**
   * Get audit trail
   *
   * @generated from rpc guardianai.v1.dispute.AdminDashboardService.GetAuditTrail
   */
  getAuditTrail: {
    methodKind: "unary";
    input: typeof AuditTrailRequestSchema;
    output: typeof AuditTrailResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_guardianai_v1_dispute_dispute, 2);

